import React, { FC } from 'react';
import { IHandledDocument, ISearchProfile } from '../../types';
import Part from './Part';
import { DocumentNamePosition } from './types';
import styles from './index.module.scss';

export interface IResultDocumentProps {
  document: IHandledDocument;
  namePosition: DocumentNamePosition;
  mainSearchProfile: ISearchProfile | null;
}

const ResultItem: FC<IResultDocumentProps> = props => {
  const { document, namePosition, mainSearchProfile } = props;

  return (
    <div className={styles.container}>
      {namePosition === DocumentNamePosition.DocumentNode && (
        <a href={document.filePath} rel="noopener noreferrer" target="_blank" className={styles.linkToSrc}>
          {document.fileName}
        </a>
      )}
      {document.parts.map((part, index) => (
        <Part
          key={index}
          part={part}
          namePosition={namePosition}
          document={document}
          mainSearchProfile={mainSearchProfile}
        />
      ))}
    </div>
  );
};

export default ResultItem;
